import Cookie from 'cookie'

import i18n, { i18nInit } from 'core/config/i18n'
import { Language } from 'common/types'

export const LANGUAGE_COOKIE = 'hmLangCookie'
export const LANGUAGE_PARAM = 'locale'
export const DEFAULT_LANGUAGE = Language.EN

class LanguageHelper {
  private currentLanguage: Language = Language.EN

  constructor() {
    const searchParams = URLSearchParams && new URLSearchParams(location.search)
    const queryLanguage = this.getSupportedLanguage(searchParams?.get(LANGUAGE_PARAM) || void 0)
    const cookieLanguage = this.getSupportedLanguage(
      Cookie.parse(document.cookie)[LANGUAGE_COOKIE]
    )
    const navigatorLanguage = this.getSupportedLanguage(navigator.language)

    this.language = queryLanguage || cookieLanguage || navigatorLanguage || DEFAULT_LANGUAGE
  }

  get language(): Language {
    return this.currentLanguage
  }

  set language(value: Language) {
    this.currentLanguage = value
  }

  setI18nLanguage = async () => {
    await i18nInit(this.language)
    i18n.changeLanguage(this.language)
  }

  private getSupportedLanguage = (languageId?: string): Language | undefined => {
    const id = languageId?.substring(0, 2).toLowerCase()

    switch (id) {
      case 'en': return Language.EN
      case 'es': return Language.ES
      case 'fr': return Language.FR
      case 'pt': return Language.PT
      default: return void 0
    }
  }
}

export default new LanguageHelper()
export { Language }
